export default __webpack_public_path__ + "static/media/th.e2e95b5e.svg";